import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { scrollToId } from "@/lib/scroll";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import ScrollScrubHero from "@/components/site/ScrollScrubHero";
import CategoryStrip from "@/components/site/CategoryStrip";
import Differentiators from "@/components/site/Differentiators";
import QuoteSection from "@/components/site/QuoteSection";
import PipelineSection from "@/components/site/PipelineSection";
import SetClassroom from "@/components/site/SetClassroom";
import HouseSection from "@/components/site/HouseSection";
import FounderSection from "@/components/site/FounderSection";
import InstructorsSection from "@/components/site/InstructorsSection";
import CoursesSection from "@/components/site/CoursesSection";
import CareerPathsSection from "@/components/site/CareerPathsSection";
import EventsSection from "@/components/site/EventsSection";
import ToolsStrip from "@/components/site/ToolsStrip";
import OutcomesSection from "@/components/site/OutcomesSection";
import Testimonials from "@/components/site/Testimonials";
import ComparisonSection from "@/components/site/ComparisonSection";
import ForYouSection from "@/components/site/ForYouSection";
import AdmissionsSection from "@/components/site/AdmissionsSection";
import FaqSection from "@/components/site/FaqSection";
import FinalCta from "@/components/site/FinalCta";
import ContactSection from "@/components/site/ContactSection";

export default function HomePage() {
  const [courses, setCourses] = useState([]);
  const [params] = useSearchParams();
  const initialProgram = params.get("enquire") || "";

  useEffect(() => {
    api.get("/courses").then((r) => setCourses(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (initialProgram) {
      const t = setTimeout(() => scrollToId("#contact"), 700);
      return () => clearTimeout(t);
    }
  }, [initialProgram]);

  return (
    <div className="bg-lima-ink text-lima-paper min-h-screen font-body" data-testid="home-page">
      <Navbar />
      <ScrollScrubHero />
      <CategoryStrip />
      <Differentiators />
      <QuoteSection />
      <PipelineSection />
      <SetClassroom />
      <HouseSection />
      <FounderSection />
      <InstructorsSection />
      <CoursesSection courses={courses} />
      <ToolsStrip />
      <OutcomesSection />
      <CareerPathsSection />
      <Testimonials />
      <ComparisonSection />
      <ForYouSection />
      <EventsSection />
      <AdmissionsSection />
      <FaqSection />
      <FinalCta />
      <ContactSection courses={courses} initialProgram={initialProgram} />
      <Footer />
    </div>
  );
}
